import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- MDC Dialog Header
import { MatDialogModule } from '@angular/material/dialog';

import { IconButtonComponent } from '@mode/capra';

@Component({
  standalone: true,
  selector: 'mode-mdc-dialog-header',
  imports: [CommonModule, IconButtonComponent, MatDialogModule],
  templateUrl: './mdc-dialog-header.component.html',
  styleUrls: ['./mdc-dialog-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MdcDialogHeaderComponent {
  @HostBinding('class') classes = 'mode-dialog-header';

  @Input()
  hideClose = false;
}
